<template>
  <div v-if="hasAccess">
    <page-submenu :links="links" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageSubmenu from '@/components/PageSubmenu.vue'

export default {
  name: 'app-dashboard-tracking-elected',
  components: {
    PageSubmenu
  },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.includes('admin') || this.roles.includes('community-manager')
    },
    links () {
      return [
        {
          label: 'Connexions',
          path: '/app/dashboard/tracking/elected/connections',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Campagnes email',
          path: '/app/dashboard/tracking/elected/email-campaigns',
          roles: ['admin', 'community-manager']
        },
        {
          label: 'Contenu publié',
          path: '/app/dashboard/tracking/elected/published-contents',
          roles: ['admin', 'community-manager']
        }
      ]
    }
  }
}
</script>
